// extracted by mini-css-extract-plugin
export default {"wrapper":"RoundIcon_wrapper__wkD5H","icon":"RoundIcon_icon__aC3KI"};